import EventHeader from "@/components/event/EventHeader";
import { Event } from "@/types/event";

interface EventDetailHeaderProps {
  event: Event;
  children?: React.ReactNode;
}

const EventDetailHeader = ({ event, children }: EventDetailHeaderProps) => (
  <EventHeader
    image={event.image_url || "/placeholder.svg"}
    title={event.title}
    description={event.description || ""}
    tags={event.tags || []}
  >
    {children}
  </EventHeader>
);

export default EventDetailHeader;
